import React from "react";
import {addDoc, collection, deleteDoc, getDocs, query, where} from "firebase/firestore";
import {appFirestore} from "../../index";
import {RRBankHolidayType} from "../types/RRBankHolidayType";
import {stringAsDepartment} from "../types/RRDepartmentType";
import {stringToDate} from "../tools";

// Hook that exposes a toggle function and current bankHolidays state
export function useBankHolidaysToggle() {
    return React.useCallback(async (departmentKey: string, dateStr: string, currentEmployee: any, setWorking?: (v: string | null) => void) => {
        if (setWorking) setWorking(dateStr);
        try {
            if (!currentEmployee?.isSuperAdmin) {
                throw new Error("NO_PERMISSION");
            }
            const dept = stringAsDepartment(departmentKey);
            // Query Firestore directly for any existing bank holiday for this date+department
            const q = query(collection(appFirestore, "bankHolidays"), where("date", "==", dateStr), where("department", "==", dept));
            const snap = await getDocs(q);
            if (snap.docs.length > 0) {
                // delete found documents
                await Promise.all(snap.docs.map(d => deleteDoc(d.ref)));
            } else {
                const dateObj = stringToDate(dateStr);
                if (!dateObj) {
                    throw new Error("INVALID_DATE");
                }
                const data: RRBankHolidayType = {
                    date: dateStr,
                    dateObject: dateObj,
                    department: dept,
                }
                await addDoc(collection(appFirestore, "bankHolidays"), data);
            }
        } finally {
            if (setWorking) setWorking(null);
        }
    }, []);
}

export default useBankHolidaysToggle;
